/**
 * @generated SignedSource<<53240012af83ce34cff52c79114e0f8f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type twoSectionTopWidgetQueue$data = {
  readonly variantTwoItems: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly " $fragmentSpreads": FragmentRefs<"contentCoverImageContent" | "contentItemRenderContent" | "entityLink">;
      };
    }>;
  } | null | undefined;
  readonly " $fragmentType": "twoSectionTopWidgetQueue";
};
export type twoSectionTopWidgetQueue$key = {
  readonly " $data"?: twoSectionTopWidgetQueue$data;
  readonly " $fragmentSpreads": FragmentRefs<"twoSectionTopWidgetQueue">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "excludeEntityIds"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "twoSectionTopWidgetQueue",
  "selections": [
    {
      "alias": "variantTwoItems",
      "args": [
        {
          "fields": [
            {
              "kind": "Variable",
              "name": "entityIds",
              "variableName": "excludeEntityIds"
            }
          ],
          "kind": "ObjectValue",
          "name": "exclude"
        },
        {
          "kind": "Literal",
          "name": "first",
          "value": 5
        }
      ],
      "concreteType": "QueueItemConnection",
      "kind": "LinkedField",
      "name": "items",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "QueueItemsEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "entityLink"
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "contentItemRenderContent"
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "contentCoverImageContent"
                    }
                  ],
                  "type": "Content",
                  "abstractKey": "__isContent"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Queue",
  "abstractKey": null
};

(node as any).hash = "387e6ae2113afcec58341376f5fa9d60";

export default node;
